import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { toPagination } from './utils';

export const IP_ADDRESS_ATTACK_SURFACE = graphql(`
  query ipAddressesAttackSurfaceQuery(
    $pagination: PaginationRequest
    $uuid: String
  ) {
    ipAddressesAttackSurface(
      filters: { submissionUuid: $uuid }
      pagination: $pagination
    ) {
      pageInfo {
        totalResults
        pageNumber
      }
      edges {
        node {
          ipv4Address
          sources
          score
          portCount
          vulnerabilityCount
        }
      }
    }
  }
`);

export function useIpAddressesAttackSurfaceQuery({
  entityUuid,
  pageNumber,
  pageSize,
}: {
  entityUuid: string;
  pageNumber: number;
  pageSize: number;
}) {
  const { loading, error, data } = useQuery(IP_ADDRESS_ATTACK_SURFACE, {
    variables: {
      uuid: entityUuid,
      pagination: toPagination(pageNumber, pageSize),
    },
  });

  //   const info = useMemo(() => {
  //     const entity = getFirstPaginatedNode(data?.entities);
  //     const alias = getFirstPaginatedNode(entity?.aliases);
  //     const insuredName = alias?.name;
  //     const coverages = getPaginatedNodes(entity?.coverages);
  //     const riskReportCoverages = coverages.map((coverage) => {
  //       return {
  //         name: coverage.name ?? 'N/A',
  //         score: coverage.score ?? 0,
  //         minScore: coverage.minScore ?? 0,
  //         maxScore: coverage.maxScore ?? 100,
  //       };
  //     });
  //     return { riskReportCoverages, entity, alias, insuredName, coverages };
  //   }, [data]);

  return {
    error,
    loading,
    data,
  };
}
